import * as XLSX from "xlsx";

export const downloadContractReportExcel = (res) => {
  if (!res || res.status !== "Success" || !res.data) return;

  const { companyName, reportDateRange, sessions = [] } = res.data;

  const worksheetData = [
    [companyName + " - " + reportDateRange],
    [],
    ["#", "Appointment Date", "Patient Name", "Quantity", "Total Price"],
  ];

  let grandTotal = 0;

  sessions.forEach((item, index) => {
    const displayDate = item.date
      ? new Date(item.date).toLocaleDateString("en-GB")
      : "N/A";

    const price = item.totalPrice || 0;
    grandTotal += price;

    worksheetData.push([
      index + 1,
      displayDate,
      item.patientName,
      item.quantity,
      price,
    ]);
  });

  worksheetData.push([], ["", "", "", "GRAND TOTAL:", grandTotal]);

  const ws = XLSX.utils.aoa_to_sheet(worksheetData);

  ws["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 4 } }];

  ws["!cols"] = [
    { wch: 5 },
    { wch: 18 },
    { wch: 30 },
    { wch: 10 },
    { wch: 15 },
  ];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Contract Report");
  XLSX.writeFile(wb, `${companyName}_Report.xlsx`);
};
